import React, { Suspense, lazy } from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import AboutMe, { Props as WidgetProps } from './AboutMe';
import reduxConnectContainer from './AboutMe.container';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import Tooltip from './Tooltip';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';
import Flag from '@wix/da-shared-react/pkg/redux/flags/Flag';

const AboutMeEditPopup = lazy(() =>
  import(/* webpackChunkName: "owner" */ './AboutMeEditPopup')
);

const enhance = compose(
  reduxConnectContainer,
  withTranslation()
);
class AboutMeBox extends React.Component<
  WidgetProps & WidgetBoxProps & WithTranslation & { isMobile: boolean }
> {
  render() {
    const {
      t,
      isMobile,
      isHeaderStickyOnMobile,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      isWide,
      hasJoinedWithEclipse,
      withFTUE,
      ...props
    } = this.props;

    const tooltipTitle = hasJoinedWithEclipse
      ? t('widgets.aboutMe.edit.tooltip.newuser.title')
      : t('widgets.aboutMe.edit.tooltip.existinguser.title');
    const tooltipContent = (
      <Flag
        condition="tooltips_ui_updates"
        render={() =>
          hasJoinedWithEclipse
            ? t('widgets.aboutMe.edit.tooltip.newuser.message')
            : t('widgets.aboutMe.edit.tooltip.existinguser.message')
        }
        fallbackRender={() => (
          <Tooltip hasJoinedWithEclipse={hasJoinedWithEclipse} />
        )}
      />
    );

    return (
      <WidgetBox
        header={t!('widgets.aboutMe.headerWithUsername', {
          username: props.user.username,
        })}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        isEmpty={isMobile && props.isEmpty}
        seeAllUrl={Url.userLink(
          props.user.username,
          `${USER_PROFILE_SECTION_PATHS.ABOUT}`
        )}
        seeAllText={t!('common.more')}
        moduleId={props.moduleId}
        allowEditOnMobile={false}
        widgetMenuRenderer={this.renderEditModal}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        editControlsTooltipTitle={tooltipTitle}
        editControlsTooltipContent={tooltipContent}
        withFTUE={withFTUE}
      >
        <AboutMe {...props} />
      </WidgetBox>
    );
  }

  renderEditModal = closeModal => {
    return (
      <Suspense fallback={<ChunkLoadingPopover />}>
        <AboutMeEditPopup
          username={this.props.user.username}
          isWide={this.props.isWide || false}
          moduleId={this.props.moduleId}
          onClose={closeModal}
        />
      </Suspense>
    );
  };
}

export default enhance(AboutMeBox) as React.ComponentType<{}>;
